// import CTASection from '#app/components/Landing-page/CTASection'
// import FaqSection from '#app/components/Landing-page/faq-section'
import FooterSection from '#app/components/Landing-page/footer-section'
import HeroSection from '#app/components/Landing-page/hero-section'
// import SecureAccessSection from '#app/components/elements/accesssecuredsection'
// import HeroSection from '#app/components/elements/herosection/'
// import FeaturesSection from '#app/components/elements/featuresection'
// import FindHouseCarousel from '#app/components/elements/findhouse/'
// import HowItWorks from '#app/components/elements/howitwork/'
// import Testimonials from '#app/components/elements/testimonials'
// import TrueTenantScoreSection from '#app/components/elements/unlockscore/index.js'
// import WhyTrueTenant from '#app/components/elements/whyTrueTenant/'
import { assets } from '#app/data/assets'
import { content } from '#app/data/content'
// import {
// 	tenantFAQItems,
// 	tenantFeatures,
// 	tenantSteps,
// } from '#app/data/marketing/tenant-data'

export default function MarketingIndexRoute() {
	// const steps = tenantSteps
	// const items = tenantFeatures
	// const faqItems = tenantFAQItems
	return (
		<div>
			{/* <HeroSection /> */}
			<HeroSection
				title={content.marketing.home.hero.title}
				buttonText={content.marketing.home.hero.buttonText}
				backgroundImage={assets.hero.banner}
			/>
			{/* <HowItWorks
				steps={steps}
				title={content.marketing.home.sections.howItWorks.title}
				subTitle={content.marketing.home.sections.howItWorks.subTitle}
			/>
			<WhyTrueTenant
				items={items}
				title={content.marketing.home.sections.whyTrueTenant.title}
				subTitle={content.marketing.home.sections.whyTrueTenant.subTitle}
			/>
			<TrueTenantScoreSection />
			<FindHouseCarousel />
			<SecureAccessSection />
			<FeaturesSection />
			<Testimonials />
			<FaqSection items={faqItems} />
			<CTASection /> */}
			<FooterSection />
		</div>
	)
}
